/**
 * Enum for job interest state.
 */
export const JobInterestState = {
  OPEN: 'OPEN',
  SHORTLISTED: 'SHORTLISTED',
  WITHDRAWN: 'WITHDRAWN',
  SELECTED: 'SELECTED',
  REJECTED: 'REJECTED',
  LISTING_CANCELLED: 'LISTING_CANCELLED',
} as const;
export type JobInterestState = (typeof JobInterestState)[keyof typeof JobInterestState];
